/* skullbomb.icon.svg.js */

"use strict";
module.exports = {
    icon: require("../common/skull.icon.svg").icon,
    toggledIcon: require("../common/bomb.icon.svg").icon,
};
